import type { ReactNode } from "react";

import { CommandList } from "./ui/command";
import { ScrollArea } from "./ui/scroll-area";

const LIST_CLASS = "space-y-1 px-3 pt-3 pb-16 pr-2";

interface CommandPaletteSourceListProps {
  readonly ariaLabel: string;
  readonly children: ReactNode;
  /**
   * Renders the rows inside Base UI's Autocomplete list so they register in the
   * composite collection and get arrow-key navigation + Enter selection. Views
   * that opt in must render `CommandItem`s rather than `<li>`s.
   */
  readonly navigable?: boolean;
}

export function CommandPaletteSourceList(props: CommandPaletteSourceListProps) {
  if (props.navigable) {
    return (
      <CommandList
        aria-label={props.ariaLabel}
        className={LIST_CLASS}
        scrollAreaClassName="min-h-0 flex-1"
      >
        {props.children}
      </CommandList>
    );
  }

  return (
    <ScrollArea scrollbarGutter scrollFade className="min-h-0 flex-1">
      <ul aria-label={props.ariaLabel} className={LIST_CLASS}>
        {props.children}
      </ul>
    </ScrollArea>
  );
}
